(() => {
  const bubble = document.getElementById('velodrom-gift-bubble');
  const policy = window.VelodromWatchGiftPolicy;
  const configElement = document.getElementById('watch-gift-config');
  if (!bubble || !policy || !configElement) return;
  const config = JSON.parse(configElement.textContent);
  const apple = policy.isApple(navigator);
  if (!config.enabled || !(apple ? config.available : config.socksAvailable)) return;
  const storageKey = 'velodrom-gift-bubble-dismissed-v1';
  let dismissed = false;
  try { dismissed = sessionStorage.getItem(storageKey) === '1'; } catch (_) { /* Storage can be disabled. */ }
  if (dismissed) return;
  const language = document.documentElement.lang.split('-')[0];
  const translations = {
  "en": {
    "eyebrow": "A little extra. On us.",
    "title": "Your next ride comes with a gift.",
    "watch": "A free Apple Watch band with orders of €300 or more.",
    "socks": "Free Raceday socks in Off White (EU 38–45) with orders of €300 or more.",
    "remaining": "{amount} to your gift",
    "included": "Your gift is in your cart",
    "checking": "Check your gift in the cart",
    "cart": "View cart →",
    "close": "Close gift offer"
  },
  "es": {
    "eyebrow": "Un detalle de nuestra parte.",
    "title": "Tu próxima ruta viene con regalo.",
    "watch": "Una correa de Apple Watch gratis en pedidos de 300 € o más.",
    "socks": "Calcetines Raceday Off White gratis (EU 38–45) en pedidos de 300 € o más.",
    "remaining": "Te faltan {amount} para tu regalo",
    "included": "Tu regalo ya está en el carrito",
    "checking": "Consulta tu regalo en el carrito",
    "cart": "Ver carrito →",
    "close": "Cerrar aviso del regalo"
  },
  "ca": {
    "eyebrow": "Un detall de part nostra.",
    "title": "La teva propera ruta ve amb regal.",
    "watch": "Una corretja d’Apple Watch gratis en comandes de 300 € o més.",
    "socks": "Mitjons Raceday Off White gratis (EU 38–45) en comandes de 300 € o més.",
    "remaining": "Et falten {amount} per al teu regal",
    "included": "El teu regal ja és al carretó",
    "checking": "Consulta el regal al carretó",
    "cart": "Veure carretó →",
    "close": "Tancar avís del regal"
  },
  "fr": {
    "eyebrow": "Une petite attention de notre part.",
    "title": "Votre prochaine sortie vient avec un cadeau.",
    "watch": "Un bracelet Apple Watch offert dès 300 € d’achat.",
    "socks": "Des chaussettes Raceday Off White offertes (EU 38–45) dès 300 € d’achat.",
    "remaining": "Plus que {amount} pour votre cadeau",
    "included": "Votre cadeau est dans votre panier",
    "checking": "Consultez votre cadeau dans le panier",
    "cart": "Voir le panier →",
    "close": "Fermer l’offre cadeau"
  },
  "de": {
    "eyebrow": "Eine kleine Aufmerksamkeit von uns.",
    "title": "Deine nächste Ausfahrt kommt mit Geschenk.",
    "watch": "Ein kostenloses Apple Watch Armband ab 300 € Bestellwert.",
    "socks": "Kostenlose Raceday Socken in Off White (EU 38–45) ab 300 € Bestellwert.",
    "remaining": "Noch {amount} bis zu deinem Geschenk",
    "included": "Dein Geschenk liegt im Warenkorb",
    "checking": "Prüfe dein Geschenk im Warenkorb",
    "cart": "Zum Warenkorb →",
    "close": "Geschenkhinweis schließen"
  },
  "it": {
    "eyebrow": "Un piccolo pensiero da parte nostra.",
    "title": "La tua prossima uscita ha un regalo in più.",
    "watch": "Un cinturino Apple Watch in omaggio con ordini da 300 €.",
    "socks": "Calzini Raceday Off White in omaggio (EU 38–45) con ordini da 300 €.",
    "remaining": "Mancano {amount} al tuo omaggio",
    "included": "Il tuo omaggio è nel carrello",
    "checking": "Controlla il tuo omaggio nel carrello",
    "cart": "Vedi carrello →",
    "close": "Chiudi l’avviso dell’omaggio"
  },
  "nl": {
    "eyebrow": "Een extraatje van ons.",
    "title": "Bij je volgende rit hoort een cadeau.",
    "watch": "Een gratis Apple Watch bandje bij bestellingen vanaf €300.",
    "socks": "Gratis Raceday sokken in Off White (EU 38–45) bij bestellingen vanaf €300.",
    "remaining": "Nog {amount} tot je cadeau",
    "included": "Je cadeau zit in je winkelwagen",
    "checking": "Bekijk je cadeau in de winkelwagen",
    "cart": "Bekijk winkelwagen →",
    "close": "Cadeaumelding sluiten"
  },
  "da": {
    "eyebrow": "En lille ekstra gave fra os.",
    "title": "Din næste tur kommer med en gave.",
    "watch": "En gratis Apple Watch rem ved køb for mindst 300 €.",
    "socks": "Gratis Raceday sokker i Off White (EU 38–45) ved køb for mindst 300 €.",
    "remaining": "Du mangler {amount} for at få din gave",
    "included": "Din gave er i kurven",
    "checking": "Se din gave i kurven",
    "cart": "Se kurven →",
    "close": "Luk gavebeskeden"
  },
  "pt": {
    "eyebrow": "Um pequeno extra. Por nossa conta.",
    "title": "A sua próxima volta vem com oferta.",
    "watch": "Uma bracelete Apple Watch grátis em encomendas a partir de 300 €.",
    "socks": "Meias Raceday Off White grátis (EU 38–45) em encomendas a partir de 300 €.",
    "remaining": "Faltam {amount} para a sua oferta",
    "included": "A sua oferta já está no carrinho",
    "checking": "Confirme a sua oferta no carrinho",
    "cart": "Ver carrinho →",
    "close": "Fechar aviso da oferta"
  },
  "pl": {
    "eyebrow": "Mały dodatek. Od nas.",
    "title": "Twoja następna jazda z prezentem.",
    "watch": "Darmowy pasek do Apple Watch przy zamówieniach od 300 €.",
    "socks": "Darmowe skarpetki Raceday w kolorze Off White (EU 38–45) przy zamówieniach od 300 €.",
    "remaining": "Brakuje {amount} do prezentu",
    "included": "Twój prezent jest w koszyku",
    "checking": "Sprawdź swój prezent w koszyku",
    "cart": "Zobacz koszyk →",
    "close": "Zamknij ofertę prezentu"
  },
  "sv": {
    "eyebrow": "Lite extra. Från oss.",
    "title": "Din nästa tur kommer med en gåva.",
    "watch": "Ett gratis Apple Watch-armband vid beställningar från 300 €.",
    "socks": "Gratis Raceday-strumpor i Off White (EU 38–45) vid beställningar från 300 €.",
    "remaining": "{amount} kvar till din gåva",
    "included": "Din gåva ligger i varukorgen",
    "checking": "Kolla din gåva i varukorgen",
    "cart": "Visa varukorgen →",
    "close": "Stäng gåvoerbjudandet"
  },
  "cs": {
    "eyebrow": "Malá pozornost od nás.",
    "title": "Vaše příští jízda přichází s dárkem.",
    "watch": "Řemínek Apple Watch zdarma k objednávkám od 300 €.",
    "socks": "Ponožky Raceday v barvě Off White zdarma (EU 38–45) k objednávkám od 300 €.",
    "remaining": "Do dárku vám chybí {amount}",
    "included": "Váš dárek je v košíku",
    "checking": "Zkontrolujte svůj dárek v košíku",
    "cart": "Zobrazit košík →",
    "close": "Zavřít nabídku dárku"
  }
};
  const copy = translations[language] || translations.en;
  const select = selector => bubble.querySelector(selector);
  select('.gift-bubble__eyebrow').textContent = copy.eyebrow;
  select('.gift-bubble__title').textContent = copy.title;
  select('.gift-bubble__description').textContent = apple ? copy.watch : copy.socks;
  select('.gift-bubble__link').textContent = copy.cart;
  select('.gift-bubble__close').setAttribute('aria-label', copy.close);
  const image = select('.gift-bubble__image');
  const imageURL = apple ? bubble.dataset.watchImage : bubble.dataset.socksImage;
  if (imageURL) image.src = imageURL;
  else image.hidden = true;
  let cart = window.VelodromWatchGift?.getCart(), ready = false, error = '', scheduled = false;
  const forms = new Set();
  const visible = element => !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).display !== 'none' && getComputedStyle(element).opacity !== '0' && !element.closest('details:not([open])');
  function obstructed() {
    return forms.size > 0 || [...document.querySelectorAll('[aria-modal="true"], dialog[open], cart-drawer.active, details.menu-opening, [role="dialog"], #shopify-pc__banner')].some(visible);
  }
  function render() {
    scheduled = false;
    const show = ready && !dismissed && cart?.currency === 'EUR' && !error && !document.hidden &&
      !policy.declined(cart.attributes?.[policy.declinedAttribute]) && !obstructed();
    if (bubble.hidden === show) bubble.hidden = !show;
    if (!show) return;
    // A gift swapped in the cart is stored as the device attribute.
    const chosen = policy.device(cart.attributes?.[policy.appleAttribute]) ?? apple;
    const description = chosen ? copy.watch : copy.socks;
    if (select('.gift-bubble__description').textContent !== description) {
      select('.gift-bubble__description').textContent = description;
      const chosenImage = chosen ? bubble.dataset.watchImage : bubble.dataset.socksImage;
      if (chosenImage) { image.src = chosenImage; image.hidden = false; }
    }
    const spend = policy.cartSpend(cart);
    const gift = cart.items.some(line => policy.isExpectedGift(line, chosen) && line.final_line_price === 0);
    const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: 'EUR' }).format(Math.max(0, policy.threshold - spend) / 100);
    const status = spend < policy.threshold ? copy.remaining.replace('{amount}', amount) : gift ? copy.included : copy.checking;
    const statusElement = select('.gift-bubble__status');
    if (statusElement.textContent !== status) statusElement.textContent = status;
    const width = `${Math.min(100, Math.max(0, spend / policy.threshold * 100))}%`;
    const progress = select('.gift-bubble__progress span');
    if (progress.style.width !== width) progress.style.width = width;
  }
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(render); }
  }
  function dismiss() {
    dismissed = true;
    bubble.hidden = true;
    observer.disconnect();
    try { sessionStorage.setItem(storageKey, '1'); } catch (_) { /* Still dismiss for this page. */ }
  }
  select('.gift-bubble__close').addEventListener('click', dismiss);
  bubble.addEventListener('keydown', event => { if (event.key === 'Escape') dismiss(); });
  window.addEventListener('klaviyoForms', event => {
    const { type, formId } = event.detail || {};
    if (type === 'open') forms.add(formId);
    if (type === 'close' || type === 'redirectedToUrl') forms.delete(formId);
    schedule();
  });
  document.addEventListener('velodrom:gift-update', event => { cart = event.detail.cart; error = event.detail.error; schedule(); });
  document.addEventListener('visibilitychange', schedule);
  const observer = new MutationObserver(records => {
    if (records.some(record => !bubble.contains(record.target))) schedule();
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open', 'hidden', 'aria-hidden', 'style'] });
  setTimeout(() => { ready = true; schedule(); }, 8000);
})();
